import(/* webpackMode: "eager" */ "/var/app/admin-portal/src/components/privacy-policy/PrivacyPolicy.tsx")